<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		watch: {
			$route(to, from) {
				if(to.path != '/login' && to.path != '/home'){
					this.$store.commit("addTab", to)
				}
			}
		},
		created() {
			this.$store.commit('initInfo')
		}
	}
</script>

<style>
</style>
